import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { CovanceFilterBaseTypeComponent } from '../covance-filter-base-type.component';
import { FilterFieldValue } from '../../covance-filter.models';
import { CovanceFilterDateTimeRangeType } from './covance-filter-date-time-range-type';

@Component({
   selector: 'covance-filter-date-time-range-type',
   template: require('./covance-filter-date-time-range-type.component.html'),
   styles: [require('./covance-filter-date-time-range-type.component.scss')]
})
export class CovanceFilterDateTimeRangeTypeComponent
    extends CovanceFilterBaseTypeComponent<CovanceFilterDateTimeRangeType>
    implements AfterViewInit, OnDestroy {

    @Input()
    public allowTimePicker: boolean;

    @Output()
    public valueChange = new EventEmitter<FilterFieldValue>();

    public isShowToSelector: boolean;

    public isShowFromSelector: boolean;

    private subscription: Subscription;

    constructor(protected filterDateRangeType: CovanceFilterDateTimeRangeType, private ref: ChangeDetectorRef) {
        super(filterDateRangeType);
        this.subscription = filterDateRangeType.changeDetector.subscribe(_ => setTimeout(() => ref.markForCheck(), 0));
    }

    public onDateRangeChange() {
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
        this.valueChange.emit(this.fieldVal);
    }

    public onDateBeginChange($event: moment.Moment) {
        if (this.fieldVal.value) {
            this.fieldVal.value.dateBegin = this.filterType.formatDateTime($event);
        }
        //an ugly fix of incorect data picker renderring when after being cleared they do not catch data from the url
        setTimeout(
            () => {
                this.filterType.setQueryParamValue(this.fieldVal);
                this.filterType.onFieldChange(this.fieldVal);
                this.valueChange.emit(this.fieldVal);
            },
            0);
    }

    public onDateEndChange($event: moment.Moment) {
        if (this.fieldVal.value) {
            this.fieldVal.value.dateEnd = this.filterType.formatDateTime($event);
        }
        setTimeout(
            () => {
                this.filterType.setQueryParamValue(this.fieldVal);
                this.filterType.onFieldChange(this.fieldVal);
                this.valueChange.emit(this.fieldVal);
            },
            0);
    }

    public ngAfterViewInit(): void {
        //https://github.com/angular/angular/issues/10816#issuecomment-307638674
        setTimeout(() => this.ref.markForCheck(), 0);
    }

    public ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public isInvalidDateRange() {
        if (!this.fieldVal.value || !this.fieldVal.value) {
            return false;
        }

        const dateBegin = moment(this.fieldVal.value.dateBegin);
        const dateEnd = moment(this.fieldVal.value.dateEnd);

        if (!dateBegin.isValid || !dateEnd.isValid) {
            false;
        }

        return dateBegin.isAfter(dateEnd);
    }

    public onShowToSelector(isShowToSelector: boolean) {
        this.isShowToSelector = isShowToSelector;
    }

    public onShowFromSelector(isShowFromSelector: boolean) {
        this.isShowFromSelector = isShowFromSelector;
    }
}
